import { BaseRequest } from './BaseRequest';

export class ProcedureRequest extends BaseRequest {
    ProcedureName: string | null;
    ProcedureParameters: Record<string, string> | null;
    
    constructor() {
        super();
        this.ProcedureName = null;
        this.ProcedureParameters = null;
    }
}